import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { PreferredDifferentiationSelector } from '../PreferredDifferentiationSelector';
import { DifferentiationListItemHeaderWrapper, DifferentiationListItemTitle, DifferentiationTitle } from './Atoms';
import { ITrajectoryDifferentiation } from 'src/config/api/models/Trajectory';
import apiRoutesV2 from 'src/config/api/routes';
import { useFetch } from 'src/modules/shared';


type Props = {
  onClick: () => void;
  withPreferenceSelection?: boolean;
  preferredVersion?: string;
  version?: ITrajectoryDifferentiation;
  trajectoryId?: string;
  isCurrentVersion?: boolean;
};

export const DifferentiationListItemHeader: React.FC<Props> = ({
  onClick,
  preferredVersion,
  withPreferenceSelection,
  version,
  trajectoryId,
  isCurrentVersion,
}) => {
  const [editTitle, setEditTitle] = useState<boolean>(false)
  const [versionTitle, setVersionTitle] = useState(version?.title);
  const [patchVersionInChapterResponse, patchVersionInChapter, Reset] = useFetch('', { method: 'PATCH' });

  const handlePatchVersion = useCallback(() => {
    setEditTitle(false)
    if(version?.title === versionTitle && !patchVersionInChapterResponse.success ) return ""
    return patchVersionInChapter({
      path: apiRoutesV2.trajectory(version?.id as string),
      body: {
        title: versionTitle,
        parent_id: trajectoryId,
      },
    });
  },[patchVersionInChapter, patchVersionInChapterResponse.success, trajectoryId, version?.id, version?.title, versionTitle])

  useEffect(() => {
    if (patchVersionInChapterResponse.success) {
      Reset();
    }
  }, [Reset, patchVersionInChapterResponse.success])

  return (
    <DifferentiationListItemHeaderWrapper>
      {!editTitle && <DifferentiationTitle 
        className={`${!version?.isOwner ? 'disabled' : ''} ${isCurrentVersion ? 'current' : 'not-current'}`}
        onClick={()=> !version?.isOwner ? {} : setEditTitle(true)}
      >
        {versionTitle || ''}
      </DifferentiationTitle>}
      {editTitle && <DifferentiationListItemTitle
        /* disabled={!version?.isOwner} */
        autoFocus
        value={versionTitle || ''}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setVersionTitle(e.target.value)}
        className={`${!version?.isOwner ? 'disabled' : ''} ${isCurrentVersion ? 'current' : 'not-current'}`}
        onBlur={handlePatchVersion}
      />}
      {withPreferenceSelection && (
        <PreferredDifferentiationSelector
          selected={preferredVersion === version?.id}
          onClick={onClick}
          withIcon
          isDefault={version?.isDefaultVersion}
          tooltip="Maak hiervan mijn voorkeursversie van dit traject."
        />
      )}
    </DifferentiationListItemHeaderWrapper>
  );
};

export default DifferentiationListItemHeader;
